export enum FeatureFlag {
    ProgressBar = "progress-bar",
    ProductSelectPage = "multi-product",
    QuoteTableHeader = "quote-table-header",
    QuoteCallToAction = "quote-call-to-action",
    AiaVitality = "aia-vitality-compare",
    DigitalAdvice = "digital-advice",
    ChubbLifeTimeReward = "chubb-lifetime-reward"
}
